import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-opera",
  "use": "icon-opera-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-opera\"><defs><style type=\"text/css\"></style></defs><path d=\"M510.048 0c-279.712 0-480.736 202.88-480.736 507.232 0 270.816 195.488 516.768 480.768 516.768 288.064 0 484.608-245.888 484.608-516.768 0-306.752-207.456-507.232-484.672-507.232zM688.352 498.528c-0.064 169.344-9.088 410.496-178.272 410.496l0 0.032c-166.784 0-173.44-241.28-173.44-410.304 0-198.368 18.56-388.576 173.44-388.576s178.272 192.576 178.272 388.352z\" fill=\"#d81e06\" p-id=\"20455\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/uas/opera.svg
// module id = 82/T
// module chunks = 16